import React, { useEffect, useState } from "react";
import styles from "./HTMLContent.module.scss";

const HTMLContent = ({ className, variant, children, html }) => {

    const [contentType, setContentType] = useState()
    
    const setVariant = (variant, className) => {

        switch(variant){
            case 'padded': return styles.padded
            case 'wrapped': return styles.wrapped
            default:
            case 'custom': return className
        }
    }


    useEffect(()=>{
        setContentType(html ? 'html' : 'child')
    },[html])
    
    if(contentType==='html') {
        return ( 
            <div 
                className={`${styles.HTMLContent} ${setVariant(variant, className)}`} 
                dangerouslySetInnerHTML={{__html:(html ? html: '' )} } />
        )
    }
    else{
        return (
            <div className={`${styles.HTMLContent} ${setVariant(variant, className)}`} >
                {children}
            </div>
        )
    }
}
export default HTMLContent;
